import { useDdcExperimentPreferences } from "@dealer-center/core-pages-experiment-enablement-hook";
import { CorePagesExperimentEnablement } from "@dealer-center/core-pages-experiment-enablement-react";

export function DdcPagesExperimentEnablement() {
  const { experiments, toggleExperiment } = useDdcExperimentPreferences();
  return (
    <CorePagesExperimentEnablement
      experiments={experiments}
      onToggleExperiment={toggleExperiment}
    />
  );
}
